var version = {
    "name":      "dativery",
    "buildDateCode": "20260123-123854",
    "buildDate": "Fri Jan 23 2026 12:38:54 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260123-123854",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;